namespace $.$$ {

	export class $shm_agent_media extends $.$shm_agent_media {

		preview_content() {
			return this.kind() === 'video' ? [ this.Preview_video() ] : [ this.Preview_image() ]
		}

		full_content() {
			return this.kind() === 'video' ? [ this.Full_video() ] : [ this.Full_image() ]
		}

		@ $mol_action
		override open( next?: Event ) {
			if( next === undefined ) return null
			this.showed( true )
			return next
		}

		@ $mol_action
		override close( next?: Event ) {
			if( next === undefined ) return null
			this.showed( false )
			return next
		}

	}

}
